// extracted by mini-css-extract-plugin
export default {"container":"LabeledContainer_container__+GW4q","name":"LabeledContainer_name__O+8q-","child":"LabeledContainer_child__LR6XS","helpmodal":"LabeledContainer_helpmodal__h1yRG"};